import { render, staticRenderFns } from "./WaitingApplications.vue?vue&type=template&id=73832ebe"
import script from "./WaitingApplications.vue?vue&type=script&lang=js"
export * from "./WaitingApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports